/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DateInterceptor implements HttpInterceptor {
  private readonly excludedEndpointPatterns = [
    /\/api\/cases\/[^/]+\/started-on/, // Matches /api/cases/{caseId}/started-on
    /\/api\/cases\/[^/]+\/completed-on/, // Matches /api/cases/{caseId}/completed-on
    /\/api\/cases\/[^/]+\/forecasted-end-date/, // Matches /api/cases/{caseId}/forecasted-end-date
    /\/api\/cases\/[^/]+\/stages\/[^/]+\/forecasted-end-date/, // Matches /api/cases/{caseId}/stages/{stageId}/forecasted-end-date
  ];

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip date transformation for excluded endpoints
    if (this.shouldExcludeEndpoint(req.url)) {
      return next.handle(req);
    }

    const cloned = req.clone({
      body: this.transformDates(req.body),
    });
    return next.handle(cloned);
  }

  private shouldExcludeEndpoint(url: string): boolean {
    return this.excludedEndpointPatterns.some((pattern) => pattern.test(url));
  }

  private transformDates(obj: any): any {
    if (obj instanceof Date) {
      return this.formatDateOnly(obj);
    } else if (Array.isArray(obj)) {
      return obj.map((v) => this.transformDates(v));
    } else if (obj && typeof obj === 'object') {
      const copy: any = {};
      for (const key of Object.keys(obj)) {
        copy[key] = this.transformDates(obj[key]);
      }
      return copy;
    }
    return obj;
  }

  private formatDateOnly(d: Date): string {
    const pad = (n: number): string => (n < 10 ? '0' + n : n.toString());
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }
}
